import React from 'react';

type MainAreaProps = {
  children: React.ReactNode;
};

const MainArea: React.FC<MainAreaProps> = ({ children }) => {
  return (
    <div className="main-area">
      {children}
    </div>
    
  );
};

export default MainArea;



